
  import QuestionTitle from '@/ui/components/inspectionReport/items/QuestionTitle.vue';
  import { defineComponent, inject } from 'vue';
  import { ItemProps } from '@/ui/components/inspectionReport/types';
  import FileItem from '@/ui/components/inspectionReport/items/FileItem.vue';
  import TableBox from '@/ui/components/inspectionReport/items/table/TableBox.vue';
  import QuestionNotes from '@/ui/components/inspectionReport/items/QuestionNotes.vue';
  import { ImageAsset } from '@/ui/components/asset/ImageAsset';
  import { DocumentAsset } from '@/ui/components/asset/DocumentAsset';
  import { isLowQualityImagesFromReportPageKey } from '@/ui/injectionKeys';
  import { isPdf } from '@/ui/helpers/systemHelper';

  export default defineComponent<ItemProps>({
    components: {
      QuestionTitle,
      DocumentAsset,
      ImageAsset,
      QuestionNotes,
      FileItem,
      TableBox,
    },
    props: ['item'],
    setup() {
      const isLowQualityImages = isPdf && inject(isLowQualityImagesFromReportPageKey, false);

      return {
        isLowQualityImages,
      };
    },
  });
